import helpers from './SyosGridHelpers';
import type SyosSeat from '../SyosSeat';

class SyosGridRow {
  seats = new Map<number, SyosSeat>();

  columnIndexes: number[] = [];

  addSeat(seat: SyosSeat) {
    this.seats.set(seat.gridColumn, seat);
  }

  finalize() {
    this.columnIndexes = Array.from(this.seats.keys())
      .sort(helpers.numericSort);
  }

  getFirstSeat() {
    return this.seats.get(this.columnIndexes[0]);
  }

  getLastSeat() {
    return this.seats.get(this.columnIndexes[this.columnIndexes.length - 1]);
  }

  getPreviousSeat(seat: SyosSeat) {
    const previousColumnNumber = helpers.getPreviousElement(this.columnIndexes, seat.gridColumn);

    if (previousColumnNumber === null) {
      return null;
    }

    return this.seats.get(previousColumnNumber);
  }

  getNextSeat(seat: SyosSeat) {
    const nextColumnNumber = helpers.getNextElement(this.columnIndexes, seat.gridColumn);

    if (nextColumnNumber === null) {
      return null;
    }

    return this.seats.get(nextColumnNumber);
  }

  getNearestSeat(seat: SyosSeat) {
    const { seats } = this;

    if (seats.has(seat.gridColumn)) {
      return seats.get(seat.gridColumn);
    }

    const closestColumnNumber = helpers.getClosestElement(this.columnIndexes, seat.gridColumn);

    return seats.get(closestColumnNumber);
  }
}

export default SyosGridRow;
